import { twMerge } from "tailwind-merge";
import ApplyButton from "./ApplyButton";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";
import applystars from "assets/images/stars.png"

export function ApplyBlock({
  text,
  textClass = "",
  buttonText,
  buttonClass = "",
  onClick = null,
  containerClass = "",
}) {
  const { dir } = useAppSelector(getSettings);
  return (
    <div
      className={twMerge(
        "flex flex-col items-center gap-10 w-fit py-12",
        containerClass
      )}
      dir={dir}
    >
      <div className="flex items-center gap-2">
        <h3 className={twMerge("text-white font-semibold text-lg", textClass)}>
          {text ?? t("thinkRightPathForYou")}
        </h3>
        <img src={applystars} alt="stars" className="w-8 h-8" />
      </div>
      <ApplyButton
        text={buttonText ?? t("applyNowButton")}
        className={buttonClass}
        onClick={onClick}
      />
    </div>
  );
}
